import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import NotificationDrawer from "../pages/Notifications/Notifications";

const HeadingBarWithSearch = ({ fullName, isSidebarOpen, setSidebarOpen }) => {
  const [showDrawer, setShowDrawer] = useState(false);
  // console.log("stafflogin window",window.location.pathname)
  const getlogo = ()=>{
    const path = window.location.pathname;
    if(path.includes('DebitTransactions') || path.includes('CreditTransactions') ||path.includes('memberships') ||path.includes('createmembership') ||path.includes('createbulkmemebership') ){
      return "/fx_logo.png";
    }
    else{
      return "/fx_logo_old.png"
    }
  }

  return (
    <div className="flex flex-wrap items-center justify-between py-2 px-4 md:px-8 shadow-[0px_4px_4px_rgba(0,0,0,0.25)] border-b bg-white w-full">
      <div className="flex items-center space-x-4">
        <Link to="/">
          <img
            src={getlogo()}
            alt="Logo"
            className="w-[140px] h-auto"
          />
        </Link>
      </div>

      {/* <div className="relative">
          <input
            type="text"
            className="w-full bg-gray-200 rounded-3xl text-slate-900 py-2 px-4 pr-10 placeholder:text-sm placeholder:font-light placeholder:text-slate-900"
            placeholder="Search"
          />
          <FaSearch
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-slate-900 font-light" />
        </div> */}

<div className="flex items-center gap-4">
  
  <img
    className="w-5 h-5 cursor-pointer"
    src="icons/notifications.svg"
    alt="Notifications"
    onClick={() => setShowDrawer(true)}
  />
  <span className="text-sm font-medium">{fullName}</span>
  <img
    className="w-8 h-8 rounded-full"
    src="https://avataaars.io/?avatarStyle=Circle"
    alt="User Avatar"
  />
  <button
    className="sm:hidden text-2xl"
    onClick={() => setSidebarOpen(!isSidebarOpen)}
  >
    {isSidebarOpen ? "✕" : "☰"} 
  </button>
</div>

<NotificationDrawer show={showDrawer} onClose={() => setShowDrawer(false)} />
    </div>
  );
};


HeadingBarWithSearch.propTypes = {
  fullName: PropTypes.string,
  isSidebarOpen: PropTypes.bool.isRequired,
  setSidebarOpen: PropTypes.func.isRequired,
};

export default HeadingBarWithSearch;
